import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PwSubmitPopupComponent } from './pw-submit-popup.component';



@NgModule({
  declarations: [
    PwSubmitPopupComponent
  ],
  imports: [
    CommonModule
  ]
})
export class PwSubmitPopupModule { }
